import axios from "../axios";

export async function fetchItemLists(params = {}) {
  return axios
    .get("/item_lists", { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching item lists:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function fetchItemList(id, params = {}) {
  return axios
    .get(`/item_lists/${id}`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching item list:", error);
      if (error.response?.status === 404) {
        throw new Error("Varehåndteringsliste ikke funnet");
      } else if (error.response?.status === 403) {
        throw new Error("Ingen tilgang til denne varehåndteringslisten");
      } else if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function createItemList(payload) {
  return axios
    .post("/item_lists", { item_list: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating item list:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function updateItemList(id, payload) {
  return axios
    .put(`/item_lists/${id}`, { item_list: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error updating item list:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function deleteItemList(id) {
  return axios
    .delete(`/item_lists/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting item list:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function approveItemList(id, comment = null) {
  const payload = comment ? { approval_comment: comment } : {};
  return axios
    .post(`/item_lists/${id}/approve`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error approving item list:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function rejectItemList(id, comment = null) {
  const payload = comment ? { approval_comment: comment } : {};
  return axios
    .post(`/item_lists/${id}/reject`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error rejecting item list:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function submitItemListForApproval(id) {
  return axios
    .post(`/item_lists/${id}/submit_for_approval`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error submitting item list for approval:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

// Item List Items API
export async function createItemListItem(itemListId, payload) {
  return axios
    .post(`/item_lists/${itemListId}/item_list_items`, { item_list_item: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating item list item:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function updateItemListItem(itemListId, itemId, payload) {
  return axios
    .put(`/item_lists/${itemListId}/item_list_items/${itemId}`, { item_list_item: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error updating item list item:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function deleteItemListItem(itemListId, itemId) {
  return axios
    .delete(`/item_lists/${itemListId}/item_list_items/${itemId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting item list item:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}

export async function handleItem(itemListId, itemId, action, storageId = null, quantity = null) {
  const payload = {
    handling: {
      action: action,
      storage_id: storageId,
      quantity: quantity
    }
  };

  return axios
    .post(`/item_lists/${itemListId}/item_list_items/${itemId}/handle_item`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error handling item:", error);
      if (error.response?.data?.errors) {
        throw new Error(error.response.data.errors.join(", "));
      }
      throw error;
    });
}
